import BaseInput from 'Components/Form/BaseInput';
import { Controller, RegisterOptions } from 'react-hook-form';
import InputMask, { Props as InputMaskProps } from 'react-input-mask';
import styles from '../../Auth/TextInput/TextInput.module.css';

export interface MaskedInputProps extends IMaskedField {
  rules?: RegisterOptions;
  disable?: boolean;
}
export const MaskedInput = ({
  name,
  type,
  placeholder,
  rules,
  disable,
  mask,
  ...rest
}: MaskedInputProps) => {
  return (
    <>
      <BaseInput name={name} {...rest}>
        {({ control }) => (
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <InputMask
                mask={mask}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
              >
                {/* @ts-ignore */}
                {(inputProps: InputMaskProps) => (
                  <input {...inputProps} className="form__input" />
                )}
              </InputMask>
            )}
          />
        )}
      </BaseInput>
    </>
  );
};
